<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e2283966" style="color: #82a339"><b>PASTA E FAGIOLI WITH SAUSAGE</b></p>
<p class="ext" id="d7e2284766"><b><i>Pasta e fagioli, Italian pasta and bean soup, becomes a meal-in-a-pot with the addition of sweet sausage and fresh spinach. Using canned beans speeds up cooking.</i></b></p>
<p class="h4" id="d7e2286366" style="color: #496210"><b>Prep: 15 minutes Cook: 1 hour</b></p>
<p class="ul" id="d7e2286866">1 pound sweet Italian-sausage links, <br/> casings removed</p>
<p class="ul" id="d7e2287466">1 tablespoon olive oil</p>
<p class="ul" id="d7e2287766">2 medium onions, chopped</p>
<p class="ul" id="d7e2288066">2 garlic cloves, crushed with garlic press</p>
<p class="ul" id="d7e2288366">1 can (28 ounces) plum tomatoes</p>
<p class="ul" id="d7e2288766">2 cans (14½ ounces each) chicken broth or 3½ cups Chicken Broth</p>
<p class="ul" id="d7e2291066">2 cups water</p>
<p class="ul" id="d7e2291666">3 cans (15 to 19 ounces) Great Northern or white kidney <br/> (cannellini) beans, rinsed and drained</p>
<p class="ul" id="d7e2292866">6 ounces ditalini or tubetti pasta (1 rounded cup)</p>
<p class="ul" id="d7e2293766">5 ounces spinach,washed and dried very well, tough stems trimmed, and leaves cut into 1-inch-wide strips <br/> freshly grated Parmesan cheese (optional)</p>
<p class="pub" id="d7e2295266" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Heat nonreactive 5-quart Dutch oven over medium-high heat until very hot. Add sausage and cook until well browned, breaking up sausage with side of spoon. Transfer sausage to bowl.</p>
<p class="pub" id="d7e2297266"><span style="color: #c15b49"><b>2.</b></span> Reduce heat to medium; add oil to Dutch oven. Add onions and cook until tender and golden, about 10 minutes. Add garlic; cook 1 minute. Add tomatoes with their juice, breaking them up with side of spoon.</p>
<p class="pub" id="d7e2299166"><span style="color: #c15b49"><b>3.</b></span> Add broth and water; heat to boiling over high heat. Reduce heat; cover and simmer 15 minutes. Add beans and heat to boiling; cover and simmer 15 minutes longer. Add sausage and heat through.</p>
<p class="pub" id="d7e2301066"><span style="color: #c15b49"><b>4.</b></span> Meanwhile, in 4-quart saucepan, cook pasta as label directs, but do not add salt to water; drain.</p>
<p class="pub" id="d7e2302066"><span style="color: #c15b49"><b>5.</b></span> Just before serving, stir spinach and cooked pasta into soup. Serve with Parmesan, if you like. Makes about 16 cups or 8 main-dish servings.</p>
<p class="ntx" id="d7e2303766">Each serving: About 558 calories, 28g protein, 65g carbohydrate, 22g total fat (7g saturated), 43mg cholesterol, 1,432mg sodium.</p>
<p class="ser"><img alt="9781618371621_0066_001" src="Images/9781618371621_0066_001.jpg" style="max-width:100%;"/></p>
<p class="cap" id="d7e2306666">Pasta e Fagioli with Sausage</p>
<div class="side"><p class="sidebarh3" id="d7e2307466" style="color: #8A4117"><b>GARNISHING SOUP</b></p>
<p class="ser"><img alt="l.jpg" src="Images/l.jpg" style="max-width:100%;"/></p>
<p class="sidebartx1" id="d7e2308166">As delicious as soup is, almost any bowl of soup will be enhanced by an added splash of color or a bit of extra flavor. Chopped fresh herbs are the simplest of all garnishes. Choose an herb that complements the soup’s flavor and color. For the best results, chop or snip fresh herbs just before using. Pureed soups can accommodate other kinds of garnishes. The smooth texture of a pureed bean or tomato soup calls out for a sprinkling of grated Parmesan cheese or crumbled bacon. Pureed vegetable soups are often topped with a drizzle of heavy cream.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c68_r1.vue?348505fd